<template>
  <div class="playback-controls">
    <!-- Modus-Anzeige -->
    <div class="mode-indicator">
      <span class="mode-badge">
        {{ modeText }}
      </span>
    </div>



    <!-- Play/Pause Button -->
    <div class="control-button-container">
      <IconButton
        size="xl"
        :variant="isPlaying ? 'secondary' : 'primary'"
        :disabled="!canPlay"
        @click="handlePlayPause"
        :aria-label="isPlaying ? 'Pause' : 'Play'"
      >
        <span class="control-icon">
          {{ isPlaying ? '⏸' : '▶' }}
        </span>
      </IconButton>
    </div>

    <!-- Status-Text -->
    <div class="status-text">
      <p v-if="!canPlay">Scanne eine Karte um zu starten</p>
      <p v-else-if="!isPlaying && !hasUserPressedPlayButton">
        Drücke Play, um den Song zu starten
      </p>
      <p v-else-if="hasUserPressedPlayButton && !isPlaying">
        Drehe dein Handy mit dem Display nach unten...
      </p>
      <p v-else-if="isPlaying">
        Song läuft! 🎵
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import IconButton from '@/components/UI/IconButton.vue';
import type { GameMode } from '@/types/spotify';

interface Props {
  mode: GameMode;
  isPlaying: boolean;
  canPlay: boolean;
  hasUserPressedPlayButton: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  play: [];
  pause: [];
}>();

const modeText = computed(() => {
  switch (props.mode) {
    case 'premium':
      return '🎵 Spotify Premium';
    case 'preview':
      return '🔊 30 Sek. Vorschau';
    default:
      return '❌ Kein Modus';
  }
});

function handlePlayPause() {
  console.log('[PlaybackControls] handlePlayPause aufgerufen');
  console.log('[PlaybackControls] props.isPlaying =', props.isPlaying);

  if (props.isPlaying) {
    console.log('[PlaybackControls] EMIT pause');
    emit('pause');
  } else {
    console.log('[PlaybackControls] EMIT play');
    emit('play');
  }
}

</script>

<style scoped lang="scss">
.playback-controls {
  @apply flex flex-col items-center gap-6;
  @apply py-8;
}

.mode-indicator {
  @apply w-full flex justify-center;
}

.mode-badge {
  @apply px-4 py-2 rounded-full;
  @apply bg-gray-800 text-white text-sm font-medium;
  @apply border border-gray-700;
}

.control-button-container {
  @apply relative;
  
  // Pulsierender Ring-Effekt
  &::before {
    content: '';
    @apply absolute inset-0 rounded-full;
    background: $spotify-green;
    opacity: 0;
    animation: controlPulse 2s infinite;
    transform: scale(1.2);
  }
}

.control-icon {
  @apply flex items-center justify-center;
  font-size: 2rem;
}

.status-text {
  @apply text-center;
  
  p {
    @apply m-0 text-gray-400 text-sm;
  }
}

@keyframes controlPulse {
  0% {
    transform: scale(1.2);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
</style>